<template lang="html">
  <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="35.2" width="27.248" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 27.247999 35.200001">
   <g transform="translate(0 -1017.2)">
    <g style="stroke:#497ea8;stroke-width:5.5931;fill:#497ea8" transform="matrix(.071516 0 0 .071516 -3.8762 1017.4)">
     <g style="stroke:#497ea8;stroke-width:5.5931;fill:#497ea8">
      <g style="stroke:#497ea8;stroke-width:5.5931;fill:#497ea8">
       <polyline style="stroke:#49a850;stroke-width:5.5931;fill:#2fc2ba" points="259.6 286.2 267.4 459 243.7 480.4 220.4 459.3 227.9 286.2"/>
       <path style="stroke:#497ea8;stroke-width:5.5931;fill:#497ea8" d="m65.904 403.9c5 0 9.1-4.1 9.1-9.1v-50.3c0-8 3.5-15.5 9.6-20.5 44.9-36.9 93.5-61.4 102.8-65.9 4.3-2.1 6.9-6.3 6.9-11.1v-70.8c0-3-1.5-5.9-4-7.5-6.7-4.5-10.7-12-10.7-20v-73.5c0-31.5 25.6-57.1 57.1-57.1h15.8c31.5 0 57.1 25.6 57.1 57.1v73.4c0 8-4 15.5-10.7 20-2.5 1.7-4 4.5-4 7.5v70.8c0 4.8 2.6 9 6.9 11.1 9.3 4.5 57.9 29.1 102.8 65.9 6.1 5 9.6 12.5 9.6 20.5v50.3c0 5 4.1 9.1 9.1 9.1s9.1-4.1 9.1-9.1v-50.3c0-13.4-5.9-26-16.3-34.5-42.5-34.9-88.3-59.2-103.1-66.6v-62.6c9.3-8 14.8-19.6 14.8-32v-73.5c0-41.5-33.7-75.2-75.2-75.2h-15.8c-41.5 0-75.2 33.7-75.2 75.2v73.4c0 12.4 5.4 24.1 14.8 32v62.8c-14.8 7.4-60.5 31.6-103.1 66.6-10.3 8.5-16.3 21.1-16.3 34.5v50.3c-.2 5.1 3.9 9.1 8.9 9.1z"/>
       <path style="fill:#497ea8" d="m268.8 258.3c-5 0-9.1 4.1-9.1 9.1 0 4.5-1.9 8.5-5 11.3-.6.4-1.2.8-1.7 1.4-2.4 1.7-5.4 2.6-8.6 2.6-8.4 0-15.3-6.8-15.3-15.3 0-5-4.1-9.1-9.1-9.1s-9.1 4.1-9.1 9.1c0 8 2.9 15.4 7.6 21.2l-7.4 170.4c-.1 2.7 1 5.3 3 7.1l23.3 21c1.7 1.6 3.9 2.3 6.1 2.3s4.4-.8 6.1-2.3l23.9-21.4c2-1.8 3.1-4.4 3-7.1l-7.6-168.4c5.6-6 9-14 9-22.8.0010-5.1-4.1-9.1-9.1-9.1zm-25.099 209.9-14.1-12.7 6.7-155.8c2.6.7 5.3 1 8.1 1 2.3 0 4.5-.2 6.6-.7l7 155.1-14.3 13.1z"/>
      </g>
     </g>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'UserProfile'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/UserProfile.vue